//region block: pre-declaration
//endregion
function get_OUTGOING_CHANNEL_CAPACITY() {
  return OUTGOING_CHANNEL_CAPACITY;
}
var OUTGOING_CHANNEL_CAPACITY;
//region block: init
OUTGOING_CHANNEL_CAPACITY = null;
//endregion
//region block: exports
export {
  get_OUTGOING_CHANNEL_CAPACITY as get_OUTGOING_CHANNEL_CAPACITY2ancx42jsldm9,
};
//endregion

//# sourceMappingURL=Utils.nonJvm.mjs.map
